var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "position_config",
      attrs: { disabled: _vm.disabled, model: _vm.value.config },
    },
    [
      _c("div", { staticClass: "tips" }, [
        _vm._v("说明：每个页面只能有一个" + _vm._s(_vm.value.widget)),
      ]),
      _c(
        "div",
        { staticClass: "box" },
        [
          _c(
            "div",
            { staticClass: "header" },
            [
              _c("div", { staticClass: "label" }, [_vm._v(" 定位配置 ")]),
              _c(
                "el-form-item",
                { attrs: { prop: "position_show" } },
                [
                  _c("el-switch", {
                    model: {
                      value: _vm.value.config.position_show,
                      callback: function ($$v) {
                        _vm.$set(_vm.value.config, "position_show", $$v)
                      },
                      expression: "value.config.position_show",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.value.config.position_show
            ? [
                _c("div", { staticClass: "title" }, [_vm._v("文字大小和颜色")]),
                _c(
                  "el-form-item",
                  { attrs: { label: "字号" } },
                  [
                    _c("el-input-number", {
                      attrs: { size: "small", min: 0 },
                      model: {
                        value: _vm.value.config.font_size,
                        callback: function ($$v) {
                          _vm.$set(_vm.value.config, "font_size", $$v)
                        },
                        expression: "value.config.font_size",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "颜色" } },
                  [
                    _c("el-color-picker", {
                      model: {
                        value: _vm.value.config.color,
                        callback: function ($$v) {
                          _vm.$set(_vm.value.config, "color", $$v)
                        },
                        expression: "value.config.color",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "title" }, [
                  _vm._v("定位图标大小和颜色"),
                ]),
                _c(
                  "el-form-item",
                  { attrs: { label: "图标尺寸" } },
                  [
                    _c("el-input-number", {
                      attrs: { size: "small", min: 0 },
                      model: {
                        value: _vm.value.config.icon_font_size,
                        callback: function ($$v) {
                          _vm.$set(_vm.value.config, "icon_font_size", $$v)
                        },
                        expression: "value.config.icon_font_size",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "颜色" } },
                  [
                    _c("el-color-picker", {
                      model: {
                        value: _vm.value.config.icon_color,
                        callback: function ($$v) {
                          _vm.$set(_vm.value.config, "icon_color", $$v)
                        },
                        expression: "value.config.icon_color",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "title" }, [
                  _vm._v("进入图标大小和颜色"),
                ]),
                _c(
                  "el-form-item",
                  { attrs: { label: "字号" } },
                  [
                    _c("el-input-number", {
                      attrs: { size: "small", min: 0 },
                      model: {
                        value: _vm.value.config.enter_icon_font_size,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.value.config,
                            "enter_icon_font_size",
                            $$v
                          )
                        },
                        expression: "value.config.enter_icon_font_size",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "颜色" } },
                  [
                    _c("el-color-picker", {
                      model: {
                        value: _vm.value.config.enter_icon_color,
                        callback: function ($$v) {
                          _vm.$set(_vm.value.config, "enter_icon_color", $$v)
                        },
                        expression: "value.config.enter_icon_color",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "box" },
        [
          _c(
            "div",
            { staticClass: "header" },
            [
              _c("div", { staticClass: "label" }, [_vm._v(" 返回按钮 ")]),
              _c(
                "el-form-item",
                { attrs: { prop: "back_button_show" } },
                [
                  _c("el-switch", {
                    attrs: { disabled: _vm.source === "home" },
                    model: {
                      value: _vm.value.config.back_button_show,
                      callback: function ($$v) {
                        _vm.$set(_vm.value.config, "back_button_show", $$v)
                      },
                      expression: "value.config.back_button_show",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.value.config.back_button_show
            ? [
                _c("div", { staticClass: "title" }, [
                  _vm._v("返回按钮大小和颜色"),
                ]),
                _c(
                  "el-form-item",
                  { attrs: { label: "字号" } },
                  [
                    _c("el-input-number", {
                      attrs: { size: "small", min: 0 },
                      model: {
                        value: _vm.value.config.back_size,
                        callback: function ($$v) {
                          _vm.$set(_vm.value.config, "back_size", $$v)
                        },
                        expression: "value.config.back_size",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "颜色" } },
                  [
                    _c("el-color-picker", {
                      model: {
                        value: _vm.value.config.back_color,
                        callback: function ($$v) {
                          _vm.$set(_vm.value.config, "back_color", $$v)
                        },
                        expression: "value.config.back_color",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }